import type { ReactNode } from "react";

/**
 * A round glass button with a tooltip (design: 56 px, 44 on phones). The tooltip
 * shows on hover and on keyboard focus (review 0012 S6); the same text is the
 * accessible name, so touch and screen readers lose nothing.
 */
export function IconButton({
  label,
  size,
  onClick,
  children,
}: {
  label: string;
  size: number;
  onClick: () => void;
  children: ReactNode;
}) {
  return (
    <button
      type="button"
      aria-label={label}
      className="group relative flex flex-none items-center justify-center rounded-full border-[1.5px] border-edge bg-panel text-ink shadow-float backdrop-blur-[10px] hover:brightness-[1.18]"
      style={{ width: size, height: size }}
      onClick={onClick}
    >
      {children}
      <span
        aria-hidden="true"
        className="pointer-events-none absolute left-1/2 top-[calc(100%+10px)] z-10 -translate-x-1/2 -translate-y-1 whitespace-nowrap rounded-[8px] border border-edge bg-panel-solid px-[11px] py-1.5 text-[12px] font-semibold opacity-0 transition-[opacity,translate] duration-150 group-hover:translate-y-0 group-hover:opacity-100 group-focus-visible:translate-y-0 group-focus-visible:opacity-100"
      >
        {label}
      </span>
    </button>
  );
}
